<template>
  <div>
    <button class="btn btn-primary" @click="$router.go(-1)"><i class="fas fa-angle-double-left"></i> 
      <span v-if="$route.params.language === 'pt'">Voltar</span>
      <span v-if="$route.params.language === 'en'">Previous</span>
      <span v-if="$route.params.language === 'es'">Anterior</span>
    </button>

    <div v-if="load" class="text-center text-secondary mt-5 mb-3">
      <i class="fas fa-3x fa-spinner fa-pulse"></i><br>
      <span v-if="$route.params.language === 'pt'">Buscando dados</span>
      <span v-if="$route.params.language === 'en'">Buscando dados</span>
      <span v-if="$route.params.language === 'es'">Buscando dados</span>
    </div>

    <div v-else>
      <h3 class="h4 mb-3">
        <span v-if="$route.params.language === 'pt'">Informações de evento:</span>
        <span v-if="$route.params.language === 'en'">Event information:</span>
        <span v-if="$route.params.language === 'es'">Información de eventos:</span>
      </h3>
      <div class="card bg-secondary text-white p-2 mb-2">
        <div class="row">
          <div class="col-sm-12 col-md-4">
            <i class="fas fa-microphone mr-1 text-indigo"></i>{{ room }}
          </div>
          <div class="col-sm-12 col-md-4">
            <div class="d-flex justify-content-center">
              <div>
                <i class="far fa-calendar"></i>&nbsp;<strong>{{ event.grid.day }}/10</strong>
                &nbsp;&nbsp;
                <i class="far fa-clock"></i>&nbsp;<strong>{{ startTime }} - {{ endTime }}</strong>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-4">
            <div class="d-flex justify-content-end">
              <span v-if="companyVerify != 'OKN Group'">
                <div v-if="event.grid.room.free_access" class="badge badge-success align-self-center">
                  <span v-if="$route.params.language === 'pt'">Conteúdo livre</span>
                  <span v-if="$route.params.language === 'en'">Free content</span>
                  <span v-if="$route.params.language === 'es'">Contenido libre</span>
                </div>
                <div v-else class="badge badge-light align-self-center">
                  <span v-if="$route.params.language === 'pt'">Conteúdo Congressista</span>
                  <span v-if="$route.params.language === 'en'">Congressman Content</span>
                  <span v-if="$route.params.language === 'es'">Contenido Congressista</span>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>

      

      <span v-for="(track, index) in event.tracks" :key="index" class="badge badge-light mr-1 border border-secondary text-capitalize">
        <i class="fas fa-circle" :style="'color:'+track.color"></i>
        {{ track.name_pt }}
      </span>

      <div v-for="(tag, index) in tags" :key="index" v-if="tag.length > 0" class="badge badge-secondary ml-1 text-capitalize">
        {{ tag }}
      </div>

      <hr>

      
      <div class="event-logo mb-3 m-auto" v-if="company">
        <img :src="'https://res.cloudinary.com/dstsh6x0y/image/upload/c_scale,w_250/v1532395371/futurecom2019/'+company.logo" alt="">
      </div>

      <h3 class="h4 mt-3 mb-3">
        <span v-if="$route.params.language === 'pt'">{{ event.title_pt }}</span>
        <span v-if="$route.params.language === 'en'">{{ event.title_en }}</span>
        <span v-if="$route.params.language === 'es'">{{ event.title_es }}</span>
      </h3>

      <p>
        <span v-if="$route.params.language === 'pt'">{{ event.description_pt }}</span>
        <span v-if="$route.params.language === 'en'">{{ event.description_en }}</span>
        <span v-if="$route.params.language === 'es'">{{ event.description_es }}</span>
      </p>
      
      <h4 class="h5 mb-2 mt-3" v-if="highLights">        
        <span v-if="$route.params.language === 'pt'">Pontos importantes no debate</span>
        <span v-if="$route.params.language === 'en'">Important points in the debate</span>
        <span v-if="$route.params.language === 'es'">Puntos clave en el debate</span>
      </h4>
      <p v-if="highLights">
        {{ highLights }}
      </p>




      <div class="list-group" v-if="event.sub_slots.length > 0">
        <div class="list-group-item list-group-item-action flex-column align-items-start active">
          <div class="d-flex w-100 justify-content-between">
            <h5 class="mb-1">
              <span v-if="$route.params.language === 'pt'">Palestras</span>
              <span v-if="$route.params.language === 'en'">Keynotes</span>
              <span v-if="$route.params.language === 'es'">Palestras</span>
            </h5>
          </div>
        </div>

        <div v-for="slot in event.sub_slots" :key="slot.id" class="list-group-item list-group-item-action flex-column align-items-start">
          <div class="d-flex w-100 justify-content-between">
            <h5 class="mb-1">
              <span v-if="$route.params.language === 'pt'">{{ slot.title_pt }}</span>
              <span v-if="$route.params.language === 'en'">{{ slot.title_en }}</span>
              <span v-if="$route.params.language === 'es'">{{ slot.title_es }}</span>
            </h5>
          </div>
          <p class="mb-1">
            <span v-if="$route.params.language === 'pt'">{{ slot.description_pt }}</span>
            <span v-if="$route.params.language === 'en'">{{ slot.description_en }}</span>
            <span v-if="$route.params.language === 'es'">{{ slot.description_es }}</span>
          </p>

          <div v-for="(speaker, index) in slot.keynotes" :key="index">
            <c-people :person="speaker"></c-people>
          </div>
        </div>

      </div>



      <div v-for="(speaker, index) in coordinators" :key="index">
        <c-people :coordinator="true" :person="speaker"></c-people>
      </div>
      <div v-for="(speaker, index) in mediators" :key="index">
        <c-people :mediator="true" :person="speaker"></c-people>
      </div>
      <div v-for="(speaker, index) in keynotes" :key="index">
        <c-people :person="speaker"></c-people>
      </div>
    </div>
  </div>
</template>
<script>
  import {HTTP} from '../axios';
  import CPeople from './info/People.vue'
  export default {
    name: 'Info',
    data() {
      return {
        event: {},
        load: true
      }
    },
    components: {
      CPeople
    },
    computed: {
      companyVerify() {
        if (this.event.company) {
          return this.event.company.company_pt
        }
        return null
      },
      tags() {
        if (this.event.tags) {
          return this.event.tags.split(',')
        }
        return null
      },
      startTime() {
        return this.event.grid.start_time.substring(11, 16)
      },
      endTime() {
        return this.event.grid.end_time.substring(11, 16)
      },
      keynotes() {
        return this.event.keynote
      },
      coordinators() {
        return this.event.coordinators
      },
      mediators() {
        return this.event.mediators
      },
      panelists() {
        return this.event.panelists
      },
      company() {
        if (this.event.company) {
          return this.event.company
        }
        return null
      },
      room() {
        if (this.$route.params.language === 'en') {
          return this.event.grid.room.name_en  
        }
        
        if (this.$route.params.language === 'es') {
          return this.event.grid.room.name_es  
        }

        return this.event.grid.room.name_pt
      },
      highLights() {
        if (this.$route.params.language === 'pt') {
          return this.event.highlights_pt
        }
        if (this.$route.params.language === 'en') {
          return this.event.highlights_en
        }
        if (this.$route.params.language === 'es') {
          return this.event.highlights_es
        }
        return null
      }
    },
    methods: {
      getSlot() {
        HTTP.get('slot-info/' + this.$route.params.uuid).then((response) => {      
          this.event = response.data
          this.load = false
        })
      }
    },
    mounted() {      
      this.getSlot()
    }
  }
</script>

<style scoped>
  .event-logo{
    width: 200px;
    height: auto;
  }
</style>





// WEBPACK FOOTER //
// src/components/About.vue